/**
 * Delte artister i sidemenyen (A9, 268.2 a). Menneskets, ikke husets: nøkkelen står under delingene,
 * så et svar på en deling (Godta, Avslå) feier lista med.
 */
import { mySharedArtistListSchema, type MySharedArtistList } from '@tvitvi/shared';
import { queryOptions } from '@tanstack/react-query';

import { CACHE } from '@/api/cache-tiers';
import { apiRequest } from '@/api/client';
import { qk } from '@/api/query-keys';

export function mySharedArtistsQueryOptions() {
  return queryOptions({
    queryKey: qk.mySharedArtists(),
    queryFn: ({ signal }): Promise<MySharedArtistList> =>
      apiRequest({ path: '/me/shares/artists', schema: mySharedArtistListSchema, signal }),
    ...CACHE.list,
  });
}
